import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

const scrollToDemo = () => document.getElementById('demo')?.scrollIntoView({ behavior: 'smooth' });

export function LandingHero() {
  return (
    <section data-testid="landing-hero" className="relative min-h-[92vh] flex items-center justify-center px-6 pt-24 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/29450016/pexels-photo-29450016.jpeg"
          alt=""
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/70 to-[#050505]" />
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-[#00E5FF]/10 blur-[120px]" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          data-testid="landing-hero-badge"
          className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-xs text-zinc-300 mb-8"
        >
          <Sparkles size={13} className="text-[#00E5FF]" />
          Para tiendas Shopify y PrestaShop
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          data-testid="landing-hero-title"
          className="text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter text-white leading-[1.05]"
        >
          Deja de perder ventas por un<br />buscador ciego y soporte fragmentado
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          data-testid="landing-hero-subtitle"
          className="mt-6 text-base md:text-lg text-zinc-400 max-w-2xl mx-auto leading-relaxed"
        >
          Aumenta la conversión con un buscador con IA que entiende a tus clientes, y ahorra
          horas unificando WhatsApp, email y pedidos en una sola bandeja.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-10 flex flex-col items-center gap-3"
        >
          <button
            data-testid="landing-hero-cta"
            onClick={scrollToDemo}
            className="sera-glow-cta rounded-full bg-[#00E5FF] text-black font-semibold px-8 py-3.5 flex items-center gap-2"
          >
            Solicita una demo <ArrowRight size={16} />
          </button>
          <span className="text-xs text-zinc-500">
            Sin compromiso.{' '}
            <Link to="/precios" data-testid="landing-hero-pricing-link" className="text-[#00E5FF] hover:underline">
              Consulta nuestros planes y precios
            </Link>
          </span>
        </motion.div>
      </div>
    </section>
  );
}
